var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "bottom" } },
    [
      _c("strong", [_vm._v("Você já tem cadastro?")]),
      _vm._v(" "),
      _c(
        "router-link",
        { attrs: { to: { name: "login" } } },
        [
          _c(
            "base-button",
            { attrs: { color: "pink", size: "large", depressed: "" } },
            [_vm._v("entrar e agendar limpeza")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6343a622", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6343a622","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignUp/ComeBack.vue
// module id = null
// module chunks = 